<template>
  <div id="home" class="common" style="height: 100%">
    <!-- 轮播图 -->
    <!-- Swiper -->
    <div class="swiper-container swiper-no-swiping " id="banner">
      <div class="swiper-wrapper">
        <!-- <a
          href="https://www.nvidia.cn/gtc-global/?ncid=partn-326051"
          target="_blank"
          class="swiper-slide swiper-slide-banner"
          style="background-image: url('https://img.deepbaytech.com/banner1.png');background-position: center center "
        ></a> -->
        <div
          class="swiper-slide swiper-slide-banner"
          style="background-image: url('https://img.deepbaytech.com/fn/home2.jpg')"
        >
          <div class="swiper-slide-title" style="text-align: center;">
            <div style="font-size: 48px;">科技引领未来 AI改变世界</div>
            <div style="font-size: 20px;margin-top:12px">
              人工智能作为新的数字疆界，将对世界产生深远的影响，改变人们的工作和生活方式
            </div>
          </div>
        </div>
        <div
          class="swiper-slide swiper-slide-banner"
          style="background-image: url('https://img.deepbaytech.com/fn/home3.jpg')"
        >
          <div class="swiper-slide-title" style="text-align: center;">
            <div style="font-size: 48px;">科技引领未来 AI改变世界</div>
            <div style="font-size: 20px;margin-top:12px">
              人工智能作为新的数字疆界，将对世界产生深远的影响，改变人们的工作和生活方式
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
    <div class="text">
      <el-row class="text-top">
        <img
          class="img-left"
          src="https://img.deepbaytech.com/images2021/ai_deepstudy.png"
        />
        <el-col class="right">
          <p class="ai-deep">AI 课程深度学习学院</p>
          <p class="nvidia">NVIDIA DLI 培训 | NVIDIA DLI课程 | NVIDIA 证书</p>
          <a
            style="margin-top: 40px;"
            class="tab-programme-a"
            href=""
            @click="routerNewsMore('/home/courses')"
            >了解详情</a
          >
        </el-col>
      </el-row>
      <el-row class="text-bottom">
        <el-col class="left">
          <p class="ai-deep">NVIDIA Ampere 架构的数据中心 GPU</p>
          <p class="nvidia">
            NVIDIA GPU服务器 Tensor Core GPU 可加速弹性数据中心，为 AI
            和数据分析应用提供动力支持。GPU服务器可高效扩展，也可借助多实例GPU
            (MIG) 技术划分为 7 个独立的
            GPU实例，从而提供统一的平台，助力弹性数据中心根据不断变化的工作负载需求动态地进行调整。
          </p>
          <!-- <a
            style="margin-top: 40px;"
            href="https://img.deepbaytech.com/NVIDIA%20A800%20TENSOR%20CORE%20GPU.pdf"
            class="tab-programme-a"
            target="_blank"
            >下载产品手册</a
          > -->
        </el-col>
        <!-- <a
              href="https://img.deepbaytech.com/NVIDIA%20A800%20TENSOR%20CORE%20GPU.pdf"
              target="_blank"
            > -->
        <img
          class="img-right"
          src="https://img.deepbaytech.com/%E4%BD%8D%E5%9B%BE%402x.png"
        />
        <!-- </a> -->
        <div v-if="show" class="box">
          <div class="icon" @click="show = false">
            <span class="span">
              <i class="el-icon-close"></i>
            </span>
          </div>
          <div class="video">
            <video
              style="width: 100%;height: 100%;"
              src="https://images.nvidia.cn/cn/data-center/dgx-a100/Introducing%20NVIDIA%20DGX%20A100_CN_v2.mp4"
              autoplay
              controls
              muted
            ></video>
          </div>
        </div>
      </el-row>
    </div>
    <div class="container common">
      <div class="fff-ds">
        <div
          class="fff-container"
          style="
"
        >
          <!--AI赋能中心-->
          <div class="fff-t">AI 赋能中心</div>
          <p class="fff-p">加速创新，为AI行业赋能，引领智慧发展</p>
          <el-row :gutter="0" type="flex" justify="center">
            <div class="fff-c fff-c-home">
              <el-col
                :xs="11"
                :sm="11"
                :md="11"
                :lg="12"
                :xl="12"
                style="display:flex;justify-content:flex-start"
              >
                <div class="fff-itm">
                  <div class="fff-itm-imgs">
                    <img
                      class="fff-itm-img"
                      src="https://img.deepbaytech.com/images2021/news.png"
                    />
                  </div>
                  <div
                    class="fff-itm-b"
                    @mouseenter="aiCloudHandle(true, $event)"
                    @mouseleave="aiCloudHandle(false, $event)"
                  >
                    <div class="fff-itb-t">AI资源调度平台</div>
                    <p class="fff-itb-c">
                      深湾科技自研AI资源调度及云计算管理平台的核心使命是为企业和科研机构提供机器学习和深度学习的全生命周期高度自动化流程工具，协助企业和科研机构的业务及技术管理者设定管理核心业务应用场景目标、协助模型训练及算法研发人员进行高效算法创新和模型训练迭代、协助基础设施管理工程师高效管理整体AI算力平台基础设施资源。
                    </p>
                  </div>
                </div>
              </el-col>
              <el-col
                :xs="11"
                :sm="11"
                :md="11"
                :lg="12"
                :xl="12"
                style="display:flex;justify-content:flex-end"
              >
                <div class="fff-itm">
                  <div class="fff-itm-imgs fff-itm-img-big">
                    <img
                      class="fff-itm-img "
                      src="https://img.deepbaytech.com/images2021/about2.png"
                    />
                    <!-- <img class="fff-itm-img-small" src="https://img.deepbaytech.com/images2021/video_light_small.png" @click="showVideo_GPU=true"> -->
                    <div v-if="showVideo_GPU" class="box">
                      <div class="icon" @click="showVideo_GPU = false">
                        <span class="span">
                          <i class="el-icon-close"></i>
                        </span>
                      </div>
                      <div class="video">
                        <video
                          style="width: 100%;height: 100%"
                          src="https://img.deepbaytech.com/fn/dgx0326.mp4"
                          autoplay
                          controls
                          muted
                        ></video>
                      </div>
                    </div>
                  </div>
                  <div
                    class="fff-itm-b"
                    @mouseenter="aiCloudHandle(true, $event)"
                    @mouseleave="aiCloudHandle(false, $event)"
                  >
                    <div class="fff-itb-t">GPU集群模型训练加速</div>
                    <p class="fff-itb-c">
                      AI资源调度平台可为GPU服务器集群提供完整的数据管理、模型管理、任务管理等全流程服务，协助AI研发人员大幅缩短底层技术学习周期、降低使用门槛，把更多宝贵的时间集中用于AI模型训练和算法创新。
                    </p>
                  </div>
                </div>
              </el-col>
              <el-col
                :xs="11"
                :sm="11"
                :md="11"
                :lg="12"
                :xl="12"
                style="display:flex;justify-content:flex-end"
              >
                <div class="fff-itm">
                  <div class="fff-itm-imgs">
                    <img
                      class="fff-itm-img"
                      src="https://img.deepbaytech.com/images2021/virtualization_platform.png"
                    />
                  </div>
                  <div
                    class="fff-itm-b"
                    @mouseenter="aiCloudHandle(true, $event)"
                    @mouseleave="aiCloudHandle(false, $event)"
                  >
                    <div class="fff-itb-t">虚拟化平台</div>
                    <p class="fff-itb-c">
                      基于虚拟GPU方案，成立虚拟化平台，可提供图形丰富的虚拟桌面和工作站。在虚拟机上运行人工智能
                      (AI)、深度学习、数据科学和高性能计算 (HPC)
                      等计算密集型服务器工作负载，并利用可管理性和安全性提升带来的优势。
                    </p>
                  </div>
                </div>
              </el-col>
              <el-col
                :xs="11"
                :sm="11"
                :md="11"
                :lg="12"
                :xl="12"
                style="display:flex;justify-content:flex-end"
              >
                <div class="fff-itm">
                  <div class="fff-itm-imgs fff-itm-img-big">
                    <img
                      class="fff-itm-img"
                      src="https://img.deepbaytech.com/images2021/about3.png"
                    />
                    <img
                      class="fff-itm-img-small"
                      src="https://img.deepbaytech.com/images2021/video_light_small.png"
                      @click="showVideo_AI = true"
                    />
                    <div v-if="showVideo_AI" class="box">
                      <div class="icon" @click="showVideo_AI = false">
                        <span class="span">
                          <i class="el-icon-close"></i>
                        </span>
                      </div>
                      <div class="video">
                        <video
                          style="width: 100%;height: 100%"
                          src="https://img.deepbaytech.com/fn/NGC0326.mp4"
                          autoplay
                          controls
                          muted
                        ></video>
                      </div>
                    </div>
                  </div>
                  <div
                    class="fff-itm-b"
                    @mouseenter="aiCloudHandle(true, $event)"
                    @mouseleave="aiCloudHandle(false, $event)"
                  >
                    <div class="fff-itb-t">AI行业软件中心</div>
                    <p class="fff-itb-c">
                      集成NVIDIA
                      NGC容器，提供针对深度学习和科学计算优化的GPU加速云平台，集成大量AI学习软件，并预置了预先训练的AI模型、模型训练脚本和行业专用软件堆栈。为开发者节省大量准备开发环境的的时间。
                    </p>
                  </div>
                </div>
              </el-col>
            </div>
          </el-row>
        </div>
      </div>
      <!-- 海量解决方案 -->
      <div class="fff-ds home-programme">
        <div class="fff-container home-programme-container">
          <div class="fff-t" style="color:#fff">海量优质的解决方案</div>
          <p class="fff-p" style="color:#fff">
            深湾科技针对行业特征及细分业务场景定制，赋能产业AI升级
          </p>
          <div class="tab">
            <ul class="tab-header" id="tabList">
              <li v-for="(item, index) in solutiondata" :key="index">
                <span
                  :class="{ 'active-tab': isShow == index }"
                  @click="tabHandle(index)"
                  class="programme-hover"
                >
                  {{ item.tabname }}
                </span>
              </li>
              <li>
                <a href="/solution" class="programme-more">更多解决方案</a>
              </li>
            </ul>
            <div class="main">
              <div
                v-for="(item, index) in solutiondata"
                :key="index"
                :class="{ 'active-main': isShow !== index }"
              >
                <p class="tab-programme-title">{{ item.tabname }}解决方案</p>
                <p class="tab-programme-text">
                  {{ item.solutionText }}
                </p>
                <a
                  class="tab-programme-a"
                  href=""
                  @click="routerNewsMore('/solution')"
                  >了解更多</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 适合业务发展的深度学习解决方案 -->
      <div class="business-development">
        <div class="business-development-title">
          AI 生态合作
        </div>
        <p class="business-development-p">
          加入AI赋能中心，推动AI技术和应用生态圈的繁荣
        </p>
        <el-row :gutter="0" type="flex" justify="center">
          <div class="business-development-container">
            <el-col
              :xs="7"
              :sm="7"
              :md="7"
              :lg="8"
              :xl="8"
              style="display:flex;justify-content:flex-start"
            >
              <div class="business-development-box">
                <div class="business-development-list">
                  <div class="business-development-list-pic">
                    <img
                      src="https://img.deepbaytech.com/images/development_1.jpg"
                      alt=""
                    />
                  </div>
                  <div
                    class="business-development-list-container"
                    @mouseenter="aiCloudHandle(true, $event)"
                    @mouseleave="aiCloudHandle(false, $event)"
                  >
                    <p class="business-development-list-container-p1">
                      AI 赋能
                    </p>
                    <p class="business-development-list-container-p2">
                      AI生态合作主旨是，结合大数据和云平台，开放AI能力，为行业提供AI应用解决方案标准化，连接产业链上下游，共同促进AI应用生态圈的共生共荣。
                    </p>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col
              :xs="7"
              :sm="7"
              :md="7"
              :lg="8"
              :xl="8"
              style="display:flex;justify-content:flex-start"
            >
              <div class="business-development-box">
                <div class="business-development-list">
                  <div class="business-development-list-pic">
                    <img
                      src="https://img.deepbaytech.com/images/development_2.jpg"
                      alt=""
                    />
                  </div>
                  <div
                    class="business-development-list-container"
                    @mouseenter="aiCloudHandle(true, $event)"
                    @mouseleave="aiCloudHandle(false, $event)"
                  >
                    <p class="business-development-list-container-p1">
                      资源支持
                    </p>
                    <p class="business-development-list-container-p2">
                      提供全方位、全流程、多维度的资源与支持，包括硬件解决支持、云数据平台支持、赋能培训支持、伙伴资源支持等。
                    </p>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col
              :xs="7"
              :sm="7"
              :md="7"
              :lg="8"
              :xl="8"
              style="display:flex;justify-content:flex-start"
            >
              <div class="business-development-box">
                <div class="business-development-list">
                  <div class="business-development-list-pic">
                    <img
                      src="https://img.deepbaytech.com/images/development_3.jpg"
                      alt=""
                    />
                  </div>
                  <div
                    class="business-development-list-container"
                    @mouseenter="aiCloudHandle(true, $event)"
                    @mouseleave="aiCloudHandle(false, $event)"
                  >
                    <p class="business-development-list-container-p1">
                      AI 解决方案
                    </p>
                    <p class="business-development-list-container-p2">
                      我们希望与各行业深度合作，共建场景应用中的AI解决方案，并将各项AI能力开放出来，成为各行各业数字化、智能化的重要帮手。
                    </p>
                  </div>
                </div>
              </div>
            </el-col>
          </div>
        </el-row>
      </div>
      <!-- 行业动态 -->
      <!-- <div class="fff-ds">
        <div class="fff-container">
          <div class="fff-t">行业动态</div>
          <p class="fff-p">加速创新，为AI行业赋能，引领智慧发展</p>
          <div style="margin-top:56px">
            <el-row :gutter="0" type="flex" justify="center">
              <el-col :xs="11" :sm="11" :md="11" :lg="12" :xl="12" style="display:flex;justify-content:flex-start">
                <div class="news-lf">
                  <video width="569px" height="295px" muted controls src="https://img.deepbaytech.com/fn/hardware0326.mp4" style="object-fit: cover;" /> -->
      <!-- <div class="news-lf-ti">深湾科技发布整体计算战略，推出全球最快AI训练集群…</div> -->
      <!-- </div>
              </el-col>
              <el-col :xs="11" :sm="11" :md="11" :lg="12" :xl="12" style="display:flex;justify-content:flex-start">
                <div class="news-rt"> -->
      <!--<div class="news-item" v-for="(item,index) in latestNews" :key="index" @click="routerNewsContent(item.id)">-->
      <!-- <div class="news-item">
                    <div class="news-rt-at"> -->
      <!--<div class="news-year">{{item.publishTime.slice(0,4)}}年</div>-->
      <!--</div>-->
      <!--<div class="news-ds-b"></div>-->
      <!--<div class="news-month">{{item.publishTime.slice(8,10)}}/{{item.publishTime.slice(5,7)}}月</div>-->
      <!--<div class="news-ds-c-d">-->
      <!--<div class="news-ti">{{item.informationTitle}}</div>-->
      <!--<p class="news-ds">{{item.informationIntroduce}}</p>-->
      <!-- <div class="news-month">05/02月</div>
                      <div class="news-year">2020年</div>
                    </div>
                    <div class="news-ds-b"></div>
                    <div class="news-ds-c-d">
                      <div class="news-ti">深湾科技发布整体计算战略，推出全球最快AI训练集…</div>
                      <p class="news-ds">
                        深湾科技发布计算战略，基于架构创新、投资全场景构建开放生态进行布局，计算产业新的大航海，加速科学研究与商业创新的智能化…</p>
                    </div>
                  </div>
                  <div class="news-item">
                    <div class="news-rt-at">
                      <div class="news-month">12/02月</div>
                      <div class="news-year">2020年</div>
                    </div>
                    <div class="news-ds-b"></div>
                    <div class="news-ds-c-d">
                      <div class="news-ti">打造无所不及的智能，构建万物互联的智能世界</div>
                      <p class="news-ds">人工智能触发的产业变革，将涉及所有行业。我们每个人都要思考。</p>
                    </div>
                  </div>
                  <div class="news-item">
                    <div class="news-rt-at">
                      <div class="news-month">01/02月</div>
                      <div class="news-year">2020年</div>
                    </div>
                    <div class="news-ds-b"></div>
                    <div class="news-ds-c-d">
                      <div class="news-ti">深湾科技DeepBay与青岛宣布达成战略合作</div>
                      <p class="news-ds">深湾科技DeepBay与青岛市宣布达成战略合作。</p>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <div class="fff-b-b" style="padding: 40px 0 60px 0;">
              <a href="/news" class="line-button" style="padding: 9px 28px;">查看更多>></a>
            </div>
          </div>
        </div>
      </div> -->
      <!--合作授权-->
      <div class="cooperation">
        <div class="cooperation-title">合作授权</div>
        <div class="cooperation-text">
          深湾科技获得美国NVIDIA公司实施交付专业服务合作伙伴（Service Delivery
          Partner-Professional
          Service）、数据中心产品增值销售、IB网络产品增值销售、AI
          Enterprise软件增值销售、DGX Cloud云服务等多项授权，获得美国DDN（Data
          Direct
          Networks）公司高速存储产品中国区增值销售合作伙伴授权，获得美国NetApp公司高速存储产品中国区增值销售合作伙伴授权，具备智算中心计算、网络、存储、软件等领域解决方案设计实施综合技术服务能力。
        </div>
        <div class="cooperation-box">
          <div class="cooperation-img">
            <img
              width="165px"
              height="32px"
              src="https://img.deepbaytech.com/%E4%BD%8D%E5%9B%BE%402x1.png"
              alt=""
            />
          </div>
          <!-- <div class="cooperation-img">
            <img
              width="157px"
              height="32px"
              src="https://img.deepbaytech.com/111697020180_.pic%402x.png"
              alt=""
            />
          </div> -->
          <div class="cooperation-img">
            <img
              width="109px"
              height="38px"
              src="https://img.deepbaytech.com/%E4%BD%8D%E5%9B%BE%402x2.png"
              alt=""
            />
          </div>
          <div class="cooperation-img">
            <img
              width="173px"
              height="32px"
              src="https://img.deepbaytech.com/netAPP%20%282%29.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <!--服务咨询-->
      <Consultation />
      <!-- 尾部 -->
      <Footer />
      <!--  -->
    </div>
  </div>
</template>
<script>
// 轮播图
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
// import 'swiper/dist/js/swiper.min.js'
// import $ from 'jquery'
import Consultation from "./../../components/Consultation/Consultation";
import Footer from "./../../components/Footer/Footer";
import { getNewsCasual } from "./../../api/index";
export default {
  name: "Home",
  components: {
    Consultation,
    Footer,
  },
  data() {
    return {
      nowSwiper: null,
      active: "",
      showVideo_GPU: false,
      showVideo_AI: false,
      show: false,
      isShow: 0,
      newslist: "",
      latestNews: "",
      solutiondata: [
        {
          tabname: "智慧安防",
          solutionText:
            "纵观安防发展历程，从“看得到”、“看得远”、“看得清”发展到今天的”看得懂“，AI技术将成为推动安防行业的主要力量，以智能方式随时随地保护城市里每一个人的生命财产安全。",
        },
        {
          tabname: "智慧金融",
          solutionText:
            "智慧金融：资深行业专家依托人工智能、大数据、云计算等金融科技手段，在业务流程、业务开拓和客户服务等方面助力企业实现金融产品、风控、获客、服务的智慧化。",
        },
        {
          tabname: "智能制造",
          solutionText:
            "将传统机器视觉与现代人工智能结合，使用大数据分析建模对工业流程与设备维护进行预测，智能优化物流运输与配货仓库，打造新一代制造业。",
        },
        {
          tabname: "智慧医疗",
          solutionText:
            "以医疗健康大数据和知识库为基础，运用机器学习、知识谱图、自然语言处理、人机交互等人工智能技术，赋予医疗健康服务和管理智能感知、学习、预警、预测等能力，为个人、医生、医院等医疗健康主体提供虚拟助理、健康管理、医院管理等场景化应用，提升医疗服务体验、提高健康管理水平、提高医院管理决策水平。",
        },
        {
          tabname: "智慧城市",
          solutionText:
            "借助功能强大的 AI 驱动型智能视频分析 (IVA)现可实现从数十亿个传感器和其他物联网 (IoT) 设备中收集数据和提取见解，可持续发展城市，维护基础设施，并为居民和社区改善公共服务。",
        },
        {
          tabname: "智慧交通",
          solutionText:
            "全球每年交通事故造成2000万至5000万人受伤，带来的损失高达5180亿美元，人工智能技术接替人类执行交通管制，7*24小时监控优化交通路况。自动驾驶、车内行驶监控、交通智能优化让驾驶更智能、规范和安全。",
        },
        {
          tabname: "智慧教育",
          solutionText:
            "借助人工智能技术人脸识别、行为分析、语音识别、知识图普大数据，对课堂情况教师学生双向智能分析，提升学生学习热情，优化教学质量。课堂行为识别能够协助双师远程教师教学，增强教学互动，助力偏远教育。",
        },
        {
          tabname: "智能文创",
          solutionText:
            "使用 AI 助手减少重复性任务，加速内容创作。 数据分析有助更深入地了解观众。",
        },
      ],
    };
  },
  mounted() {
    this.getNewsFuc();
    // 轮播图 · 初始化设定
    this.nowSwiper = new Swiper(".swiper-container", {
      loop: true,
      speed: 500,
      autoplay: true, //设置自动循环播放
      lazy: {
        loadPrevNext: true,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  },
  methods: {
    tabHandle(flag) {
      this.isShow = flag;
    },
    aiCloudHandle: function(mode, event) {
      var parentNode = event.target.parentNode;
      if (mode) {
        parentNode.classList.add("hoveractive");
      } else {
        parentNode.classList.remove("hoveractive");
      }
    },
    routerNewsMore(path) {
      // var isShowNumber = JSON.stringify(this.isShow);
      // sessionStorage.setItem("setisShowNumber",isShowNumber);
      this.$router.push(path);
    },
    async getNewsFuc() {
      this.result = await getNewsCasual();
      console.log(this.result);
      this.newslist = this.result.data;
      console.log(this.newslist);
      for (var i = 0; i < 1; i++) {
        this.latestNews = this.newslist[i].latestNews;
        console.log(this.newslist[i].latestNews);
      }
    },
    routerNewsContent(id) {
      this.$router.push({
        path: `/newsContent/${id}`,
      });
    },
    latestNewsFuc() {},
  },
  updated() {},
};
</script>
<style scoped>
#home {
  position: relative;
}
.common {
  min-width: 1180px;
}
.swiper-container {
  height: 560px;
}
.swiper-slide-banner {
  width: 100%;
  height: 560px !important;
}
.swiper-slide-banner img {
  width: 100%;
  height: 100%;
}
.first-banner {
  width: 100px;
  height: 100px;
  background-image: url("../../../public/images/banner.png") no-repeat 5px 5px;
}
.swiper-slide {
  position: relative;
  background-size: cover;
}
.swiper-slide-title-nvidia {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding-top: 0px !important;
}
.swiper-slide-title {
  color: #fff;
  width: 1180px;
  margin: 0 auto;
  padding-top: 210px;
}
.swiper-pagination .swiper-pagination-bullet {
  width: 40px;
  height: 4px;
  border-radius: 0;
  background: #fff;
  opacity: 0.5;
}
::v-deep .swiper-pagination-bullet-active {
  opacity: 1 !important;
  background-color: #77ba00 !important;
}
.text {
  background: #f6f8fb;
}
.text-top {
  display: flex;
  height: 320px;
  width: 100%;
  max-width: 1180px;
  margin: 80px auto 0;
  align-items: center;
}
.img-left {
  width: 580px;
  height: 320px;
}
.right {
  width: 560px;
  margin-left: 40px;
}
.ai-deep {
  color: #333;
  font-size: 24px;
  line-height: 33px;
  font-weight: 400;
}
.nvidia {
  width: 560px;
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  line-height: 22px;
  margin-top: 20px;
}
.text-bottom {
  display: flex;
  height: 320px;
  width: 100%;
  max-width: 1180px;
  margin: 80px auto 60px;
  align-items: center;
}
.left {
  width: 560px;
}
.img-right-box {
  position: relative;
}
.img-right {
  width: 580px;
  height: 320px;
  margin-left: 40px;
}
.img-right-in {
  width: 96px;
  height: 96px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.5;
}
.box {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  overflow: hidden;
  z-index: 9999;
}
.icon {
  width: 50px;
  height: 50px;
  position: absolute;
  top: 30%;
  left: 73%;
  /* -webkit-transform: translate(-50%); */
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.3);
  /* -webkit-box-shadow: 0 0 5px rgb(0 0 0 / 40%); */
  box-shadow: 0 0 5px rgb(0 0 0 / 10%);
  border-radius: 50%;
  text-align: center;
  line-height: 50px;
  color: #fff;
  font-size: 20px;
  z-index: 9998;
}
.span {
  font-family: element-icons !important;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  vertical-align: baseline;
  display: inline-block;
  -webkit-font-smoothing: antialiased;
}
.video {
  width: 800px;
  height: 600px;
  position: relative;
  left: 50%;
  top: 50%;
  /* -webkit-transform: translate(-50%, -50%); */
  transform: translate(-50%, -50%);
}
/*fffff*/
.container {
  width: 100%;
  /* background: #f6f8fb; */
  /* min-width: 1180px; */
}
.fff-ds {
  color: #333;
}
.fff-container {
  width: 100%;
  max-width: 1180px;
  margin: auto;
}
.fff-t {
  color: #333333;
  font-size: 32px;
  text-align: center;
  padding-top: 20px;
}
.fff-p {
  text-align: center;
  padding-top: 18px;
  color: #333333;
  font-size: 20px;
}
/* xin */
.fff-c-home {
  /* width: 84%; */
  width: 100%;
  margin: auto;
}
.fff-c {
  margin-top: 60px;
  margin-right: 20px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.fff-itm {
  /* width: 550px; */
  max-width: 280px;
  height: 470px;
  width: 100%;
  margin-right: 20px;
  background: #fff;
  overflow: hidden;
  /* border-radius: 4px; */
  transition: 0.5s;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
}
.hoveractive {
  transform: translateY(-20px);
}
.fff-itm-imgs {
  /* width: 550px;
        height: 320px; */
  overflow: hidden;
}
.fff-itm-img {
  width: 280px;
  height: 228px;
  transition: 0.5s;
}
.fff-itm-img:hover {
  transform: scale(1.2, 1.2);
}
.fff-itm-img-big {
  position: relative;
}
.fff-itm-img-small {
  position: absolute;
  width: 40px;
  height: 40px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.fff-itm-b:hover .fff-itm {
  color: red;
}
.fff-itb-t {
  font-size: 16px;
  color: #333333;
  font-weight: 500;
  line-height: 22px;
  margin-top: 16px;
  margin-left: 16px;
}
.fff-itb-c {
  line-height: 22px;
  margin-top: 12px;
  margin-left: 16px;
  color: #666666;
  line-height: 20px;
  font-weight: 400;
  font-size: 14px;
}
.fff-b-b {
  width: 100%;
  text-align: center;
}
/*  */
.tab {
  display: flex;
  margin-top: 63px;
}
.tab-header {
  list-style: none;
}
.tab-header li {
  width: 100px;
  height: 34px;
  cursor: pointer;
  text-align: center;
  margin: 12px 74px;
  font-size: 16px;
  color: #fff;
}
.main {
  padding-left: 6%;
  padding-top: 6px;
}
.programme-hover {
  display: inline-block;
}
.active-tab {
  font-size: 20px;
  border-bottom: 2px solid #77ba00;
  padding-bottom: 4px;
}
.programme-hover:hover {
  font-size: 20px;
  border-bottom: 2px solid #77ba00;
  padding-bottom: 4px;
}
.active-main {
  display: none;
}
.tab-programme-title {
  font-size: 30px;
  color: #fff;
  font-size: 500;
}
.tab-programme-text {
  margin-top: 32px;
  font-size: 16px;
  color: #fff;
}
.tab-programme-a {
  display: inline-block;
  width: 120px;
  height: 40px;
  font-size: 14px;
  color: #fff;
  text-align: center;
  line-height: 40px;
  background: #77ba00;
  text-decoration: none;
  margin-top: 78px;
}
.home-programme {
  width: 100%;
  background: url("https://img.deepbaytech.com/images2021/home_bg_programme.png");
  background-size: 100% 100%;
  margin-top: 80px;
}
.home-programme-container {
  padding-bottom: 70px;
}
.programme-more {
  text-decoration: none;
  color: rgba(255, 255, 255, 0.6);
}
.programme-more:hover {
  color: #77ba00;
}
/*  */
.news-lf {
  position: relative;
  width: 100%;
  max-width: 569px;
  height: 100%;
  max-height: 295px;
  overflow: hidden;
}
.news-lf-img {
  width: 100%;
  height: 100%;
  transition: 0.5s;
}
.news-lf-img:hover {
  transform: scale(1.2);
}
.news-lf-ti {
  position: absolute;
  width: 100%;
  bottom: 0;
  padding: 18px;
  color: #fff;
  font-size: 18px;
  background-color: rgba(0, 0, 0, 0.5);
}
.news-rt {
  flex: 1;
  margin-left: 60px;
  height: 300px;
  overflow: hidden;
}
.news-item {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  cursor: pointer;
}
.news-item:last-child {
  margin-bottom: 0;
}
.news-rt-at {
  width: 100px;
  text-align: center;
}
.news-month {
  font-size: 22px;
}
.news-year {
  font-size: 14px;
  color: #666;
}
.news-ds-b {
  width: 1px;
  height: 72px;
  margin: 0 16px;
  background-color: #eaeaea;
}
.news-ti {
  font-size: 18px;
  width: 390px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  color: #333333;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.news-ti:hover {
  color: #77ba00;
}
.news-ds {
  color: #666;
  max-width: 432px;
  font-size: 14px;
  padding-top: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-button {
  text-decoration: none;
  font-size: 16px;
  color: #333;
}
/* 适合业务发展的深度学习解决方案 */
.business-development {
  width: 100%;
  height: auto;
  background: #fff;
  margin-top: 80px;
}
.business-development-title {
  width: 100%;
  text-align: center;
  color: #333333;
  font-size: 32px;
}
.business-development-p {
  text-align: center;
  padding-top: 18px;
  color: #333333;
  font-size: 20px;
}
.business-development-container {
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
  height: 100%;
  padding-top: 60px;
  /* padding-bottom: 60px; */
  display: flex;
  justify-content: space-between;
}
/* xin */
.business-development-box {
  width: 100%;
  height: 100%;
}
.business-development-list {
  max-width: 365px;
  height: auto;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 6px 23px -8px rgba(144, 144, 144, 0.33);
  color: #333333;
  transition: 0.5s;
  margin: auto;
}
.active-development {
  transform: translateY(-20px);
  color: #fd6622 !important;
  box-shadow: 0 9px 28px -6px rgba(182, 182, 182, 0.33);
}
.business-development-list-pic {
  max-width: 365px;
  height: 100%;
  overflow: hidden;
}
.business-development-list-pic img {
  width: 100%;
  height: 100%;
  transition: 0.5s;
}
.business-development-list-pic img:hover {
  transform: scale(1.2, 1.2);
}
.business-development-list-container {
  padding: 40px;
  height: 174px;
}
.business-development-list-container-p1 {
  font-size: 24px;
}
.business-development-list-container-p1:hover {
  color: #77ba00;
}
.business-development-list-container-p2 {
  padding: 12px 0 50px 0;
  width: 100%;
  color: #666666;
  line-height: 27px;
  overflow: hidden;
  font-size: 14px;
}
.bfooter {
  width: 100%;
  height: 200px;
  background: #010017;
  color: #ececef;
  font-size: 16px;
}
.bfooter-content {
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
}
.bfooter-list {
  display: flex;
  justify-content: space-between;
  padding: 44px 0;
  border-bottom: 1px solid #333;
}
.bfooter-text {
  padding-top: 20px;
  text-align: center;
  font-size: 12px;
}
.bannerOne {
  display: block;
  background-image: url("https://img.deepbaytech.com/%E7%9F%A9%E5%BD%A2.png");
}

@media screen and (min-width: 1440px) {
  .bannerOne {
    /* background-image: url('https://img.deepbaytech.com/fn/nvidia-deep0324-1.jpg'); */
    /* background-size: contain; */
    background-position: center;
    background-color: #000;
    background-repeat: no-repeat;
  }
}
.cooperation {
  width: 100%;
  background: #f6f8fb;
  padding-bottom: 80px;
}
.cooperation-title {
  color: #333333;
  font-size: 28px;
  text-align: center;
  margin-top: 80px;
  padding-top: 80px;
}
.cooperation-text {
  width: 1180px;
  color: #333333;
  font-size: 16px;
  text-align: center;
  margin: 20px auto 40px;
}
.cooperation-box {
  width: 1180px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.cooperation-img {
  width: 320px;
  height: 80px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
